// src/store/creditSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  enabled : false,
  balance : 0,      // remaining credit
  limit   : 0,      // total limit (optional, nice for UI)
};

const creditSlice = createSlice({
  name: 'credit',
  initialState,
  reducers: {
    setCredit (state, action) {
      const { enabled, balance, limit } = action.payload;
      state.enabled = !!enabled;
      state.balance = balance ?? 0;
      state.limit   = limit   ?? state.limit;
    },
    adjustCredit (state, action) {
      // payload = +amount OR -amount
      state.balance += action.payload;
    },
    clearCredit (state) { Object.assign(state, initialState); },
  },
});

export const { setCredit, adjustCredit, clearCredit } = creditSlice.actions;
export default creditSlice.reducer;
